export const LogStatusEnum = {
  processing: "Processing",
  completed: "Delivered",
  failed: "Failed",
} as const;

export const SendStatusEnum = {
  ...LogStatusEnum,
  pending: "Pending",
  scheduled: "Scheduled",
  cancelled: "Cancelled",
} as const;

export const sendTypeEnum = {
  sendNow: "Send Now",
  scheduled: "Scheduled",
} as const;

export const timezoneTypeEnum = {
  EST: "EST",
  RegionalTime: "Regional Time",
} as const;

export const EmailTypeEnum = {
  dataPrivacy: "GDPR Data Privacy",
  informational: "Informational",
  marketing: "Marketing",
  invitationInformation: "Meeting",
  newtworkWire: "Network Wire",
  pressReleases: "Press Releases",
  memberCollaboration: "Success Collaboration",
  viewpoints: "Viewpoint Bulletin",
} as const;

export const EmailTypeMemberEnum = {
  informational: "General",
  marketing: "Member Insight",
  invitationInformation: "Meeting Invitation and Information",
  newtworkWire: "Network Wire Quarterly Newsletter",
  pressReleases: "Press Releases",
  memberCollaboration: "Member Collaboration",
  viewpoints: "Viewpoint Bulletin: Trending Topics Quarterly",
  dataPrivacy: "GDPR Data Privacy",
} as const;

export type SendStatusType = keyof typeof SendStatusEnum;
export type SendType = keyof typeof sendTypeEnum;
export type TimezoneType = keyof typeof timezoneTypeEnum;
export type EmailType = keyof typeof EmailTypeEnum;
